import React, { useEffect, useMemo, useState } from 'react';

import classNames from 'classnames';

import { Bell } from 'features/order-tracker/shared-components/svg';
import { useLivePersonPageChange } from 'features/order-tracker/store/hooks/useLivePersonPageChange';

import styles from './styles.module.scss';

export const Tabs: React.FC<components.Tabs> = ({ tabs = [], renderDependencies }) => {
  const [activeTab, setActiveTab] = useState(tabs[1]?.title);
  const activeTabInfo = useMemo(
    () => tabs.find(({ title }) => activeTab === title),
    [activeTab, ...renderDependencies],
  );

  useEffect(() => useLivePersonPageChange(), [activeTab]);

  if (!tabs.length) {
    return null;
  }

  return (
    <div>
      <div className={styles.tabsContainer}>
        {tabs.map(({ title }, index) => (
          <div key={title} className={classNames(styles.buttonWrapper, { [styles.active]: activeTab === title })}>
            <button type="button" key={title} onClick={() => setActiveTab(title)}>
              {title}
            </button>
            {!!index && (
              <div className={styles.bellIcon}>
                <Bell />
              </div>
            )}
          </div>
        ))}
      </div>
      {activeTabInfo?.content}
    </div>
  );
};
